import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import useReveal from "@/hooks/useReveal";
import { ArrowUpRight } from "@phosphor-icons/react";

export default function CaseStudies() {
  const ref = useReveal();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/case-studies").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <section id="cases" ref={ref} data-testid="cases" className="reveal section border-b border-[color:var(--line)]">
      <div className="container-x">
        <div className="mb-12">
          <div className="eyebrow">Case studies</div>
          <h2 className="font-display font-black text-4xl md:text-5xl mt-4 leading-[1.02] max-w-3xl">
            Selected proof, from teams you might already know.
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {items.map((c) => (
            <Link
              to={`/case-studies/${c.slug || c.id}`}
              key={c.id}
              data-testid={`case-${c.client.toLowerCase().replace(/\s+/g, "-")}`}
              className="card-line p-8 group block"
            >
              <div className="flex items-center gap-3">
                <span className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">{c.industry}</span>
                <span className="w-4 h-px bg-neutral-300" />
                <span className="font-mono text-[10px] uppercase tracking-widest text-[color:var(--brand)]">{c.client}</span>
              </div>
              <h3 className="mt-4 font-display font-bold text-2xl md:text-3xl leading-tight">{c.title}</h3>
              <p className="mt-3 text-neutral-600 leading-relaxed">{c.summary}</p>
              <div className="mt-6 border-t border-[color:var(--line)] pt-4 flex items-center justify-between">
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">Outcome</div>
                  <div className="mt-1 font-display font-bold">{c.result}</div>
                </div>
                <ArrowUpRight size={22} weight="bold" className="text-neutral-400 group-hover:text-[color:var(--brand)] transition-colors duration-200" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
